import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { DayjsFormatterPipe } from '@app/pipes/framework/dayjs-formatter.pipe';
import { FadedTextComponent } from '@app/framework/faded-text/faded-text.component';
import { StatusBlockComponent } from '@app/pages/webapp/projects/view-project/rfi-listing/status-block/status-block.component';
import { submittalsSelectors } from '@app/store/submittals/submittals.selectors';
import { NotificationV2Service } from '@app/notification-v2.service';

@Component({
  selector: 'app-submittal-package-details-tab',
  imports: [DayjsFormatterPipe, FadedTextComponent, StatusBlockComponent],
  templateUrl: './submittal-package-details-tab.component.html',
  styleUrl: './submittal-package-details-tab.component.scss',
})
export class SubmittalPackageDetailsTabComponent {
  store = inject(Store);
  notif = inject(NotificationV2Service);

  submittalPackage = toSignal(this.store.select(submittalsSelectors.selectPackageDetails));
}
